import { ActionTypes } from "../constants";

export default function dashboard(state = {}, action) {

  switch(action.type) {
    case ActionTypes.SET_NEWS:
      return {
        ...state,
        newsArticles: action.payload
      };
    case ActionTypes.SET_BLOG:
      var updatedState = {
        ...state,
        blogArticles: action.payload
      };
      return updatedState;
    case ActionTypes.SET_TRENDING_FUNDS:
      return {
        ...state,
        trending: action.payload
      };
    case ActionTypes.SET_TOP_PICKS:
      return {
        ...state,
        topPicks: action.payload
      };
    default:
      return state;
  }
}